<template>
  <div class="memberIndex">
    <div class="right">
      <div class="currentMenu">供应商谈判/单一来源> 谈判报价</div>
      <div class="right_content">
        <div class="change_inform">
          <div class="title">谈判报价</div>
        </div>
        <div class="right_out">
          <div style="padding: 5px; margin: 10px">
            <span>项目名称</span>
            <el-input type="text" class="input" v-model="Query.ProjectName" size="mini"></el-input>
            <span>招标方式</span>
            <el-select class="input" v-model="Query.PurchaseMethod" placeholder="请选择">
              <el-option v-for="item in PurchaseMethods" :key="item.Value" :label="item.Text" :value="item.Value"> </el-option>
            </el-select>
            <span>项目类型</span>
            <el-select class="input" v-model="Query.ProjectType" placeholder="请选择">
              <el-option v-for="item in ProjectTypes" :key="item.Value" :label="item.Text" :value="item.Value"> </el-option>
            </el-select>
            <el-button id="search" @click="fnGetData">搜索</el-button>
          </div>
          <el-table class="table_wrap1" :data="tableData.slice((currentPage - 1) * PageSize, currentPage * PageSize)" style="width: 100%" :height="height">
            <el-table-column type="expand" style="padding: 0">
              <template slot-scope="props">
                <table class="statistics_table">
                  <tr>
                    <th class="th1">包组信息</th>
                    <th class="th1" style="width: 120px">状态</th>
                    <th class="th1" style="width: 240px">操作</th>
                  </tr>
                  <tr v-for="(item, index) in props.row.schemeList" :key="index">
                    <td class="td1">{{ item.ProjectName }}-{{ item.GroupName }}</td>
                    <td class="td1">
                      <div>
                        <span>{{ item.Status }}</span>
                      </div>
                    </td>
                    <td class="td1">
                      <div class="btn_wrap">
                        <el-button class="btn" @click="fnUpload(item.AutoId, item.SchemeId, item.ProjectName)" type="text" v-if="item.IsExitBid == false && item.CanOperation == true" size="small"
                          >再次报价</el-button
                        >
                        <el-button class="btn" type="text" size="small" @click="fnRecall(item.AutoId)" v-if="item.IsExitBid == false && item.CanOperation == true">退出谈判</el-button>
                      </div>
                    </td>
                  </tr>
                </table>
              </template>
            </el-table-column>
            <el-table-column prop="SchemeCode" label="采购编号"></el-table-column>
            <el-table-column prop="ProjectName" label="项目名称">
              <template slot-scope="scope">
                <el-link class="link" @click="Detail(scope.row.SchemeId)" :underline="false">{{ scope.row.ProjectName }} </el-link>
              </template>
            </el-table-column>
            <el-table-column prop="PurchaseMethod" label="采购方式"></el-table-column>
            <el-table-column prop="ProjectType" label="项目类型"></el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="pageSizes"
            :page-size="PageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'aboutUs',
  components: {},
  data() {
    return {
      Query: {},
      tableData: [],
      PurchaseMethods: [],
      ProjectTypes: [],
      ownPurchaseMethod: [4, 5],
      currentPage: 1,
      // 总条数，根据接口获取数据长度(注意：这里不能为空)
      totalCount: 1,
      // 个数选择器（可修改）
      pageSizes: [10, 25, 50, 100],
      // 默认每页显示的条数（可修改）
      PageSize: 25,
      height: window.innerHeight - 268
    }
  },
  created() {},
  computed: {},
  mounted() {
    this.AddListener()
    this.fnInit()
    this.fnGetData()
    // this.getData();
  },
  methods: {
    fnRecall(AutoId) {
      this.$confirm('是否确认退出谈判？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        //确认撤标
        this.postRequest('/Purchase/ConfirmNegotiation', {
          AutoId: AutoId,
          ConfirmBidding: false,
          ssjson: ''
        })
          .then((res) => {
            var data = res.data
            if (data.errcode == 0) {
              this.fnGetData()
            } else {
              this.$message.error(data.errmsg)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      })
    },
    fnGetData() {
      let config = {
        params: {
          Query: JSON.stringify(this.Query)
        }
      }

      this.getRequest('Purchase/GetNegotiationListList', config)
        .then((res) => {
          if (res.data.errcode == 0) {
            this.tableData = res.data.TenderDocList
            this.totalCount = this.tableData.length
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    fnInit() {
      //获取登录供应商基础信息
      this.getRequest('SupplierLogin/MemberCenterData')
        .then((res) => {
          if (res.data.errcode == 0) {
            this.loginInfos = res.data.logindata
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      let config = {
        params: {
          PurchaseMethod: JSON.stringify(this.ownPurchaseMethod)
        }
      }
      //获取下拉列表
      this.getRequest('Purchase/GetInvitationQueryList', config)
        .then((res) => {
          if (res.data.errcode == 0) {
            this.PurchaseMethods = res.data.PurchaseMethods
            this.ProjectTypes = res.data.ProjectTypes
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    AddListener() {
      window.addEventListener('storage', (e) => {
        if (e.key == 'TenderDocList') {
          this.fnGetData()
        }
      })
    },
    fnUpload(AutoId, SchemeId, ProjectName) {
      //打开上传投标文件界面
      let routerData = this.$router.resolve({
        name: 'NegotiationQuotation',
        query: {
          AutoId: AutoId,
          SchemeId: SchemeId,
          ProjectName
        }
      })
      window.open(routerData.href, '_blank')
    },
    // 分页
    // 每页显示的条数
    handleSizeChange(val) {
      // 改变每页显示的条数
      this.PageSize = val
      // 注意：在改变每页显示的条数时，要将页码显示到第一页
      this.currentPage = 1
    },
    // 显示第几页
    handleCurrentChange(val) {
      // 改变默认的页数
      this.currentPage = val
    }
  }
}
</script>
<style scoped lang="scss">
.memberIndex {
  display: flex;

  .left {
    width: 250px;
    min-width: 250px;
    background: #4f99d7;

    .logined_wrap {
      padding: 10px;

      .title span:nth-of-type(1) {
        font-weight: bold;
        color: #fff;
        margin-right: 5px;
      }

      .btn {
        border-top: 1px dashed #2db7f5;
        padding-top: 10px;
        margin-top: 10px;
      }

      .img {
        margin-left: 30px;
      }

      .list {
        li {
          font-size: 12px;
          padding: 5px 0;
          color: #d3e7f3;
          display: flex;
          align-items: center;

          .labell {
            font-weight: bold;
          }

          img {
            margin-right: 5px;
          }
        }
      }
    }
  }

  .right {
    width: 100%;
    background: #e4e4e4;
    // flex: 1;
    padding: 0 0 10px 0;

    .right_out {
      width: 98%;
      margin: 0 auto;
    }

    .currentMenu {
      margin: 16px 5px;
    }

    .right_content {
      margin: 0 10px;
      // height: 93%;
      background: #f7f7f7;
      padding-bottom: 10px;
    }

    #search {
      width: 120px;
    }

    .input {
      width: 180px;
      margin-right: 50px;
      margin-left: 5px;
    }

    ::v-deep.el-input--mini .el-input__inner {
      height: 28px;
      line-height: 28px;
    }

    .btn_wrap {
      .btn {
        margin: auto;
        color: #6a96bc;
        border: 1px solid #6a96bc;
        border-radius: 5px;
        padding: 2px 18px;
      }
    }
  }
}

.block_wrap {
  display: flex;
}

.left_block {
  flex: 3;

  .flex_block {
    display: flex;

    .block {
      flex: 1;
      background: #fff;
      margin-right: 20px;
      text-align: center;
      align-items: center;
      padding: 13px 0;

      .text1 {
        font-size: 46px;
        color: #219cf8;
      }

      .text2 {
        margin-top: 4px;
        color: #054c81;
      }
    }

    .block:nth-last-of-type(1) {
      margin-right: 0;
    }
  }
}

.flex_bottom {
  padding: 10px 15px 3px;
  background: #fff;
  margin-top: 10px;

  .fb_title {
    margin-bottom: 0;
  }
}

.right_block {
  width: 220px;
  background: #fff;
  margin-left: 10px;
  padding: 18px 15px 0;

  .text {
    font-size: 16px;
    border-bottom: 1px solid #95c7f0;
    padding-bottom: 3px;
    font-weight: bold;
  }

  .row_imgs {
    display: flex;
    margin: 15px 0 25px;

    .img_block {
      flex: 1;
      text-align: center;
      cursor: pointer;

      img {
        margin-bottom: 20px;
      }
    }
  }

  .row_imgs:nth-last-of-type(1) {
    margin-top: 33px;
  }
}

.link {
  color: #0361b1;
  padding-right: 10px;
}
.statistics_table {
  width: 100%;
  // margin: 5px auto;

  th,
  td {
    text-align: center;
  }

  th {
    background-color: rgba(243, 251, 255, 1);
    color: #0179bd;
    font-weight: 700;
  }
}
</style>